<template>
    <el-dropdown trigger="click" popper-class="dropdown-style" @visible-change="handleLanVisibleChange">
        <div class="language-header">
            <!-- <span class="earth"> -->
            <el-icon><Timer /></el-icon>
            <!-- </span> -->
            {{ getCurrentTimezone }}
            <el-icon>
                <ArrowUp v-if="lanVisible" />
                <ArrowDown v-else />
            </el-icon>
        </div>
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item
                    v-for="item in timezoneList"
                    :key="item.value"
                    :class="getCurrentTimezone === item.value ? 'selected' : ''"
                    @click="changeTimezone(item.value)"
                >
                    <div style="width: 110px; display: flex; justify-content: space-between; align-items: center">
                        <span>{{ item.label }}</span>
                        <el-icon v-if="getCurrentTimezone === item.value">
                            <Check />
                        </el-icon>
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import {ref, watch, computed, nextTick} from 'vue';
import {defineUserStore} from '@/stores/user';
import {useI18n} from 'vue-i18n';

const userStore = defineUserStore();
const {locale} = useI18n();

const timezone = computed(() => {
    return userStore.timezone;
});
const lanVisible = ref(false);
const handleLanVisibleChange = (val: boolean) => {
    lanVisible.value = val;
};

const allTimezoneList = [
    {
        label: 'UTC+8',
        value: 'UTC+8'
    },
    {
        label: 'EST',
        value: 'EST'
    },
    {
        label: 'UTC+0',
        value: 'UTC+0'
    }
];
const timezoneList = ref(allTimezoneList);

const getCurrentTimezone = computed(() => {
    const obj: any = timezoneList.value.find((item: any) => item.value === timezone.value) || timezoneList.value[0];
    return obj.value;
});

const changeTimezone = (timezone: string) => {
    localStorage.setItem('timezone', timezone);
    userStore.setTimezone(timezone);
    nextTick(() => {
        userStore.setComponentKey();
    });
};
</script>

<style lang="scss" scoped>
.language-header {
    height: 32px;
    padding: 10px 16px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
        border-color: var(--el-color-primary);
    }
    &[aria-expanded='true'] {
        border-color: var(--el-color-primary);
    }
    .earth {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-size: 100%;
        background-image: url(../../assets/images/earth.png);
    }
}
</style>
<style lang="scss">
.dropdown-style {
    .el-dropdown-menu__item.selected {
        color: var(--el-color-primary);
    }
    .el-dropdown-menu__item:not(.is-disabled):focus {
        background-color: var(--el-dropdown-menuItem-hover-fill);
        color: #5d6171;
    }
    .selected.el-dropdown-menu__item[tabindex='0']:focus {
        background-color: var(--el-dropdown-menuItem-hover-fill);
        color: #0068e3;
    }
}
</style>
